import Vue from "vue";

async function getAsyncGlobalVariable(variableName) {
	while (!Vue.prototype.$chamaileon[variableName]) {
		// eslint-disable-next-line no-await-in-loop
		await new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, 200);
		});
	}

	return Vue.prototype.$chamaileon[variableName];
}

export default {
	getAsyncGlobalVariable,
};
